import React from 'react';
import './ProblemLocation.css';

export default function ProblemLocation({ setFormInfo }) {
  const setProblemLocation = () => {
    setFormInfo((prevValue) => {
      return {
        ...prevValue,
        problemLocation: { locationSelection: true },
      };
    });
  };

  return (
    <div className="problem-location-container">
      Označite lokaciju kvara na mapi.
      <button
        type="submit"
        className="pl-close-button"
        onClick={setProblemLocation}
      >
        Označi
      </button>
    </div>
  );
}
